// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.output_states_port__vT2b3,
.output_states_hoverablePort__6RSP2 {
  background-color: #ccc;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  position: absolute;
  top: 0;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.output_states_hoverablePort__6RSP2:hover:not(.output_states_active__yWN8W) {
  background-color: #bdbdbd;
}

.output_states_hoverablePort__6RSP2:active {
  background-color: #01b20b;
}

.output_states_active__yWN8W {
  background-color: #01b20b;
}

.output_states_section__HxOh5 {
  font-family: "Lexend Variable", sans-serif;
  color: #284480;
  font-size: 15px;
  font-weight: 500;
  line-height: 29px;
  letter-spacing: 0.04em;
  display: flex;
  border-bottom: #284480 2px solid;
  flex-basis: 50%;
  justify-content: center;
  align-items: center;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  border-radius: 10px 10px 0 0;
}

.output_states_header__sygPZ {
  display: flex;
  margin-top: 20px;
}

.output_states_activeSection__7rK1T {
  background-color: #ecf0f8;
  color: #6a86c8;
  border-bottom: transparent 2px solid;
}

.output_states_portLabel__vJC64 {
  font-family: "Lexend Variable", sans-serif;
  font-weight: 500;
  font-size: 14px;
}

.output_states_custom-input__q\\+7Ie {
  background-color: #ecf0f8;
  border: none;
  border-radius: 8px;
  padding: 8px 12px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  color: #000;
  text-align: center;
  -moz-appearance: textfield;
  max-width: 7rem;
}

.output_states_custom-name-input__WsRbF {
  background-color: #ecf0f8;
  border: none;
  border-radius: 8px;
  padding: 8px 12px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  color: #000;
  text-align: center;
  -moz-appearance: textfield;
  width: 100%;
  max-width: none;
}

.output_states_small-custom-name-input__Y4FIU {
  background-color: #ecf0f8;
  border: none;
  border-radius: 8px;
  padding: 8px 12px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  color: #000;
  text-align: center;
  -moz-appearance: textfield;
  width: 70px;
  max-width: none;
}

.output_states_custom-container__QDdSh {
  width: 300px;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.output_states_custom-input__q\\+7Ie::-webkit-outer-spin-button,
.output_states_custom-input__q\\+7Ie::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.output_states_custom-input__q\\+7Ie:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.output_states_input-container__DC7rU {
  display: flex;
  align-items: center;
  justify-content: center;
}

.output_states_input-container__DC7rU svg {
  margin-right: 8px;
}

.output_states_error-input__6gvYD {
  border-color: red;
  box-shadow: 0 0 0 2px rgba(255, 0, 0, 0.5);
}

.output_states_error-message__D50Ex {
  color: red;
  margin-top: 10px;
  font-weight: bold;
}

.output_states_fso-container__t0OZd {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/screens/detail/modals/output_states/index.module.css"],"names":[],"mappings":"AAAA;;EAEE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV","sourcesContent":[".port,\n.hoverablePort {\n  background-color: #ccc;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  position: absolute;\n  top: 0;\n  color: #ffffff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.hoverablePort:hover:not(.active) {\n  background-color: #bdbdbd;\n}\n\n.hoverablePort:active {\n  background-color: #01b20b;\n}\n\n.active {\n  background-color: #01b20b;\n}\n\n.section {\n  font-family: \"Lexend Variable\", sans-serif;\n  color: #284480;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 29px;\n  letter-spacing: 0.04em;\n  display: flex;\n  border-bottom: #284480 2px solid;\n  flex-basis: 50%;\n  justify-content: center;\n  align-items: center;\n  user-select: none;\n  cursor: pointer;\n  border-radius: 10px 10px 0 0;\n}\n\n.header {\n  display: flex;\n  margin-top: 20px;\n}\n\n.activeSection {\n  background-color: #ecf0f8;\n  color: #6a86c8;\n  border-bottom: transparent 2px solid;\n}\n\n.portLabel {\n  font-family: \"Lexend Variable\", sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.custom-input {\n  background-color: #ecf0f8;\n  border: none;\n  border-radius: 8px;\n  padding: 8px 12px;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  color: #000;\n  text-align: center;\n  -moz-appearance: textfield;\n  max-width: 7rem;\n}\n\n.custom-name-input {\n  background-color: #ecf0f8;\n  border: none;\n  border-radius: 8px;\n  padding: 8px 12px;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  color: #000;\n  text-align: center;\n  -moz-appearance: textfield;\n  width: 100%;\n  max-width: none;\n}\n\n.small-custom-name-input {\n  background-color: #ecf0f8;\n  border: none;\n  border-radius: 8px;\n  padding: 8px 12px;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  color: #000;\n  text-align: center;\n  -moz-appearance: textfield;\n  width: 70px;\n  max-width: none;\n}\n\n.custom-container {\n  width: 300px;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n}\n\n.custom-input::-webkit-outer-spin-button,\n.custom-input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.custom-input:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n.input-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.input-container svg {\n  margin-right: 8px;\n}\n\n.error-input {\n  border-color: red;\n  box-shadow: 0 0 0 2px rgba(255, 0, 0, 0.5);\n}\n\n.error-message {\n  color: red;\n  margin-top: 10px;\n  font-weight: bold;\n}\n\n.fso-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"port": `output_states_port__vT2b3`,
	"hoverablePort": `output_states_hoverablePort__6RSP2`,
	"active": `output_states_active__yWN8W`,
	"section": `output_states_section__HxOh5`,
	"header": `output_states_header__sygPZ`,
	"activeSection": `output_states_activeSection__7rK1T`,
	"portLabel": `output_states_portLabel__vJC64`,
	"custom-input": `output_states_custom-input__q+7Ie`,
	"custom-name-input": `output_states_custom-name-input__WsRbF`,
	"small-custom-name-input": `output_states_small-custom-name-input__Y4FIU`,
	"custom-container": `output_states_custom-container__QDdSh`,
	"input-container": `output_states_input-container__DC7rU`,
	"error-input": `output_states_error-input__6gvYD`,
	"error-message": `output_states_error-message__D50Ex`,
	"fso-container": `output_states_fso-container__t0OZd`
};
export default ___CSS_LOADER_EXPORT___;
